import { combineReducers } from "redux"
import { connectRouter } from "connected-react-router"
import globalReducer from "./globalReducer"
import prismicReducer from "./prismicReducer"

const reducer = history =>
  combineReducers({
    router: connectRouter(history),
    global: globalReducer,
    prismic: prismicReducer
  })

export default reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js